import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {handleActiveToast} from "../../components/sonner/ToastBasic";

async function getCompanyList(search, pageable) {
    console.log(">> 업체List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/company?'+pageStr, search);
    }catch (error){
        return error;
    }
}

async function getCompany(id) {
    try{
        return  await needAuth.get('/company/'+id);
    }catch (error){
        return error;
    }
}

async function saveCompany(data, images, files) {

    const formData = new FormData();
    images.forEach((image, index) => {
        formData.append(`images`, image);
    });
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "companyRequestDto",
        new Blob([JSON.stringify(data)], { type: "application/json" })
    );

    try {
        return await needAuth.post(`/company/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    } catch (error) {
        return error;
    }
}

async function removeCompanies(ids) {
    try{
        const response = await needAuth.put('/company/delete', ids);
        return response;
    }catch (error){
        if (error instanceof AxiosError) {
            if(error.response.status === 500) {
                handleActiveToast({message: "하위 계열사가 존재합니다"});
            }
        }
        return error.response.status;
    }
}

async function getTopCompanylist() {
    console.log(">>> api : 최상위 업체 조회")
    try{
        return  await needAuth.get('/company/top');
    }catch (error){
        return error;
    }
}

async function updateCompany(data) {

    try {
        const response = await needAuth.put(`/company/${data.id}`, data);
        return response;
    } catch (error) {
        if (error instanceof AxiosError) {
            if(error.response.status === 500) {
                handleActiveToast({message: "업체명이 중복됩니다."});
            }
        }
        return error.response.status;
    }
}

async function selectCompanyFlatListBySearch (search){
    return await needAuth.post(`/company/flatList`, search);
}


export {getCompanyList, saveCompany, getTopCompanylist, removeCompanies, updateCompany, getCompany, selectCompanyFlatListBySearch};